import React, {Fragment, useEffect} from 'react';
import M from 'materialize-css';

import GaleriaDrGuerrero from '../../Components/Galerias/DrGuerrero';
import Desktop from '../../Components/Desktop';

import dg1 from '../../Images/Proyectos/dg.png';
import dg2 from '../../Images/Proyectos/Galerias/Dr-Guerrero/10.png';


const DrGuerrero = () => {
    
    useEffect(() => {
      var elems = document.querySelectorAll('.sidenav');
      M.Sidenav.init(elems);
    });


    return (
      <Fragment>

        <img className="center-img dimensionar-imagen-movil" alt="" src={dg1}></img>

        <div className='container'>
          {window.screen.width >= 993 ? (
            <p className='texto' style={{textAlign:"center"}}>
              Para el reconocido cirujano plástico del hospital Innovare <br />
              creamos una página web que cumpla con la calidad de sus servicios. <br /><br />
              Al ser un cirujano reconocido internacionalmente, <br />
              se requirió que la información del sitio web estuviera también disponible en inglés. <br /><br />
              En el sitio bilingüe encontrarás la información de cualquier <br />
              procedimiento quirúrgico que él realice, así como los cuidados postoperatorios, <br />
              testimonios, instalaciones y aparatología que puedes incluir en tu procedimiento.
            </p>
          ) :(
            <p className='texto' style={{textAlign:"center"}}>
              Para el reconocido cirujano plástico del hospital Innovare 
              creamos una página web que cumpla con la calidad de sus servicios. <br /><br />
              Al ser un cirujano reconocido internacionalmente, 
              se requirió que la información del sitio web estuviera también disponible en inglés. <br /><br />
              En el sitio bilingüe encontrarás la información de cualquier 
              procedimiento quirúrgico que él realice, así como los cuidados postoperatorios, 
              testimonios, instalaciones y aparatología que puedes incluir en tu procedimiento. 
            </p>
          )}
        </div>


        <Desktop images={{desktop: "javierGuerreroDesktop", laptop:"javierGuerreroLaptop", movil: "javierGuerreroMovil"}} />

        <div className='container'>
          <GaleriaDrGuerrero/>
        </div>

        <div className='dimensionar-imagen-dg'>
          <img className="center-img" alt="" src={dg2}></img>
        </div>

        <div style={{display:"flex", justifyContent:"center", marginBottom:"50px"}}>
          <div className='btn_1'>
            <a href="#portafolioSofwareOver" style={{color:"#fff"}}>
              <p>
                Ver más del portafolio
              </p>
            </a>
          </div>
        </div>
        
      </Fragment>
    );
}

export default DrGuerrero;
